'use strict';

var projectLoadHelper = require('../../helper/projectLoadHelper');
var directToNext = false;

var Preview = {
  untoStack: [],
  redoStack: [],
  onOpenHome: function () {
    var firstPage = projectLoadHelper.getAppFirstPage();
    if (firstPage) {
      this.onOpenPage(firstPage.ID);
    }
  },
  onOpenPrev: function () {
    var prev = this.untoStack.pop();
    if (prev) {
      this.props.onOpenPage(prev);
      this.redoStack.push(this.props.current.ID);
    }
    directToNext = true;
  },
  onOpenNext: function () {
    var next = this.redoStack.pop();
    if (next) {
      this.props.onOpenPage(next);
      this.untoStack.push(this.props.current.ID);
    }
    directToNext = false;
  },
  onOpenPage: function (id, animation) {
    if (id === 'command:back') {
      this.onOpenPrev();
      return;
    }
    this.untoStack.push(this.props.current.ID);
    this.props.onOpenPage(id, animation);
  },
  onPlayback: function () {
    if (directToNext) {
      return this.onOpenNext();
    }
    this.onOpenPrev();
  }
};

module.exports = Preview;


/** WEBPACK FOOTER **
 ** ./src/views/Mixin/Preview.jsx
 **/